import React, { Component } from "react";
import PropTypes from "prop-types";
import { GridColumn } from "arv-reactcomponents";
import { HIDE_BRANDNAME } from "npmlinks-constants";

class ProductDescription extends Component {
  get productData() {
    const { product, currentView } = this.props;
    return {
      brand: (product && product.brand) || "",
      name: (product && product.styleName) || "",
      description: `${product.color} | ${product.size} ${
        currentView === "mybag" ? "" : `| Qty: ${product.qty}`
      }`,
    };
  }
  render() {
    const { brand, name, description } = this.productData;
    const { currentView } = this.props;
    return (
      <GridColumn
        className={`nwc-grid-col-sm-${
          currentView === "mybag" ? "4" : "12"
        } nw-cartproductview-description`}
      >
        {!HIDE_BRANDNAME && (
          <h3 className="nw-cartproductview-brandname">{brand}</h3>
        )}
        <p className="nw-cartproductview-name">{name}</p>
        <p className="nw-cartproductview-colorandsize">{description}</p>
      </GridColumn>
    );
  }
}

ProductDescription.propTypes = {
  product: PropTypes.shape({}).isRequired,
  currentView: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductDescription,
  component: ProductDescription,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/ProductDescription/index.js